export default __webpack_public_path__ + "static/carousel2-d260c6a2d325e1f957422cb710b1709a.png";